export default "__VITE_ASSET__917f1402__"